const Icon: React.FC<IconProps> = ({ color = "white", width = "26px", height = "26px" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M13 20C16.866 20 20 16.866 20 13C20 9.13401 16.866 6 13 6C12.1418 6 11.3198 6.15442 10.56 6.437C11.4235 6.96371 12 7.91453 12 9C12 10.6569 10.6569 12 9 12C7.91453 12 6.96371 11.4235 6.437 10.56C6.15442 11.3198 6 12.1418 6 13C6 16.866 9.13401 20 13 20Z" fill={color} />
      <circle cx="13" cy="13" r="11.25" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};

export default Icon;
